import { Injectable } from "@angular/core";
import { AppConfigService } from "./app-config.service";

@Injectable({
  providedIn: 'root'
})
export class FileService {
  private readonly apiUrl: string;

  constructor(private readonly appConfigService: AppConfigService) {
    this.apiUrl = this.appConfigService.getConfig().apiUrl;
  }

  getUrl(id?: string): string | null {
    if (!id) {
      return null;
    }

    return `${this.apiUrl}/api/File/${id}`;
  }
}
